import ChangeMFA from 'views/Authentication/ChangeMFA';
import ChangePassword from 'views/Authentication/ChangePassword';
import ConfirmAccount from 'views/Authentication/ConfirmAccount';
import ForgotPassword from 'views/Authentication/ForgotPassword';
import Loginscreen from 'views/Authentication/Loginscreen';
import Maintenance from 'views/Maintenance';
import PrivacyPolicy from 'views/PublicPages/PrivacyPolicy';
var commonRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Loginscreen,
  },
  {
    path: '/change-password/:resetToken',
    name: 'Change Password',
    component: ChangePassword,
  },
  {
    path: '/change-password/',
    name: 'Change Password',
    component: ChangePassword,
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword,
  },
  {
    path: '/change-mfa',
    name: 'Change MFA',
    component: ChangeMFA,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy,
  },
  {
    path: '/account-confirmation/:confirmToken',
    name: 'Change Password',
    component: ConfirmAccount,
  },
  {
    path: '/account-confirmation/',
    name: 'Confirm Account',
    component: ConfirmAccount,
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
  },
];
export default commonRoutes;
